import type { FC } from "preact/compat";
import type { IconButtonProps } from "./interfaces";
import cn from "classnames";

const IconButton: FC<IconButtonProps> = ({
    children,
    className,
    onClick,
    title,
}) => (
    <button
        type="button"
        className={cn(
            "p-2 bg-white rounded-full border border-gray-300 text-gray-500 fill-current",
            "hover:text-sky-500 hover:border-sky-500",
            "focus:outline-none focus:ring-2 focus:ring-sky-500 focus:ring-offset-[3px] focus:ring-offset-white-100 focus:text-sky-500",
            className
        )}
        onClick={onClick}
        title={title}
    >
        {children}
    </button>
);

export default IconButton;
